import { Component } from '@theme/component';
import { CartAddEvent } from '@theme/events';
import { DrawerOpenEvent } from '@theme/theme-drawer';

const CART_SUMMARY_STICKY_THRESHOLD = 0.5;

class CartDrawerComponent extends Component {
  get #themeDrawer() {
    return this.closest('theme-drawer');
  }

  get #dialog() {
    return this.closest('dialog');
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#themeDrawer?.addEventListener(DrawerOpenEvent.eventName, this.#handleDrawerOpen);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#themeDrawer?.removeEventListener(DrawerOpenEvent.eventName, this.#handleDrawerOpen);
  }

  #handleCartAdd = () => {
    if (!this.hasAttribute('auto-open')) return;

    const themeDrawer = this.#themeDrawer;
    if (typeof themeDrawer?.open === 'function') themeDrawer.open();
  };

  #handleDrawerOpen = () => {
    this.#updateStickyState();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const cta = this.querySelector('shopify-payment-terms')?.shadowRoot?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', () => {
        const themeDrawer = this.#themeDrawer;
        if (typeof themeDrawer?.close === 'function') themeDrawer.close();
      }, { once: true });
    });
  };

  #updateStickyState() {
    const dialog = this.#dialog;
    if (!dialog) return;

    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;
    dialog.setAttribute('cart-summary-sticky', ratio > CART_SUMMARY_STICKY_THRESHOLD ? 'false' : 'true');
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
